/**
 *
 * Button
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import AKButton from '@atlaskit/button';
import theme from 'styles/theme';

export const Button = ({
  loading,
  children,
  width,
  opacity,
  fontSize,
  background,
  height,
  padding,
  border,
  iconBefore,
  floatRight,
  margin,
  color,
  ...others
}) => {
  return (
    <AKButton
      {...others}
      isLoading={loading}
      iconBefore={iconBefore}
      theme={(currentTheme, themeProps) => {
        const { buttonStyles, ...rest } = currentTheme(themeProps);
        return {
          buttonStyles: {
            ...buttonStyles,
            background:
              others.appearance === 'primary'
                ? theme.palette.primary
                : background || buttonStyles.background,
            width: width ? `${width}px` : 'auto',
            height,
            opacity,
            color:
              others.appearance === 'primary' ? theme.palette.white : color || buttonStyles.color,
            float: floatRight ? 'right' : null,
            fontSize: fontSize || '12px',
            fontWeight: others.appearance === 'primary' ? '500' : 'normal',
            padding: padding || '2px 8px',
            margin,
            borderRadius: '5px',
            border,
            '&:hover': {
              opacity: '1',
            },
            '&:focus': {
              outline: 'none',
              boxShadow: 'none',
            },
          },
          ...rest,
        };
      }}
    >
      {children}
    </AKButton>
  );
};

Button.propTypes = {
  loading: PropTypes.bool,
};

export default Button;
